import * as Sentry from '@sentry/react';

export function initSentry() {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    sendDefaultPii: false,
    // Enable logs to be sent to Sentry
    enableLogs: true,
    tracesSampleRate: 0,
    ignoreErrors: [
      // ResizeObserver
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',

      // React DOM 타이밍 이슈
      /Failed to execute 'removeChild' on 'Node'/,
      /Failed to execute 'insertBefore' on 'Node'/,
      /The node to be removed is not a child of this node/,

      // Firefox 확장
      "TypeError: can't access dead object",

      // 네트워크 (fetch 레벨만)
      /Failed to fetch/,
      /Load failed/,
      /NetworkError when attempting to fetch resource/,

      // 요청 취소
      /AbortError/,

      // Instagram / 카카오 등 인앱 브라우저 모듈 로딩 실패
      // ES Module을 지원하지 않는 인앱 브라우저 환경에서 발생
      'TypeError: Importing a module script failed.',
      /Importing a module script failed/,
    ],

    beforeSend(event) {
      // errorSource 태그가 붙은 이벤트는 코드에서 의도적으로 captureException 한 것이다.
      // 인앱 브라우저 사용자의 실패율도 측정해야 하므로 아래 필터를 통과시킨다.
      // (카카오톡 유입 비중이 큰 서비스라 이들을 빼면 실패 통계가 실제와 크게 달라진다.)
      if (event.tags?.errorSource) {
        return event;
      }

      // Instagram, KakaoTalk 등 인앱 브라우저에서 발생한 에러 무시
      // ES Module 미지원 등으로 잡음이 많아 자동 수집분은 통째로 거른다.
      const ua = navigator.userAgent;
      if (/Instagram|KAKAOTALK|NAVER|Line\//.test(ua)) {
        return null;
      }
      return event;
    },

    denyUrls: [
      /extensions\//i,
      /^chrome:\/\//i,
      /^chrome-extension:\/\//i,
      /^moz-extension:\/\//i,
      /^safari-extension:\/\//i,
    ],
    release: import.meta.env.VITE_APP_VERSION,
  });
}